import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const entCarrerasApi = `${baseUrl}/entidad-carreras`;
export const entCarDocentesApi = `${baseUrl}/entidad-carrera-docentes`;

export const allEntCarrerasService = async (params) => {
  const res = await axios.get(entCarrerasApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveEntCarrerasService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${entCarrerasApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(entCarrerasApi, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneEntCarrerasService = async (id) => {
  const res = await axios.get(`${entCarrerasApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteEntCarrerasService = async (id) => {
  const res = await axios.delete(`${entCarrerasApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const asignarEntCarDocentesService = async (data) => {
  const res = await axios.post(`${entCarDocentesApi}`, data, {
    headers: token({}),
  });
  return res;
};

export const deleteEntCarDocentesService = async (id) => {
  const res = await axios.delete(`${entCarDocentesApi}/${id}`, {
    headers: token({}),
  });
  return res;
};
